/**
 * @file reportUtils.js
 * @description Shared utility functions for report components.
 */

import { ReportStatusIds } from '../../utils/data/enums';

function normalizeStatusId(value) {
    const asNumber = Number(value);
    if (!Number.isNaN(asNumber) && Number.isFinite(asNumber)) {
        return asNumber;
    }

    return null;
}

const STATUS_LABEL_BY_ID = {
    [ReportStatusIds.PENDING]: 'Pending',
    [ReportStatusIds.COMPLETED]: 'Completed',
    [ReportStatusIds.ERROR]: 'Error',
    [ReportStatusIds.IN_PROGRESS]: 'In Progress',
};

export function getStatusLabelFromReportStatusId(reportStatusId) {
    const normalizedStatusId = normalizeStatusId(reportStatusId);

    if (normalizedStatusId && STATUS_LABEL_BY_ID[normalizedStatusId]) {
        return STATUS_LABEL_BY_ID[normalizedStatusId];
    }

    return String(reportStatusId || '');
}
